import { Action } from '@ngrx/store';
import * as dashboardTypes from './dashboard.types'


export class FetchPropertyGeneralRequest implements Action {
    readonly type = dashboardTypes.FETCH_PROPERTY_GENERAL_REQUEST;
    constructor() { }
}

export class FetchPropertyGeneralSuccess implements Action {
    readonly type = dashboardTypes.FETCH_PROPERTY_GENERAL_SUCCESS;
    constructor(public payload: any) { }
}

export class FetchPropertyGeneralFailure implements Action {
    readonly type = dashboardTypes.FETCH_PROPERTY_GENERAL_FAILURE;
    constructor(public payload: any) { }
}


export class FetchBusinessGeneralRequest implements Action {
    readonly type = dashboardTypes.FETCH_BUSINESS_GENERAL_REQUEST;
    constructor() { }
}

export class FetchBusinessGeneralSuccess implements Action {
    readonly type = dashboardTypes.FETCH_BUSINESS_GENERAL_SUCCESS;
    constructor(public payload: any) { }
}

export class FetchBusinessGeneralFailure implements Action {
    readonly type = dashboardTypes.FETCH_BUSINESS_GENERAL_FAILURE;
    constructor(public payload: any) { }
}

// Common

export class UpdateField implements Action {
    readonly type = dashboardTypes.UPDATE_FIELD;
    public constructor(public field: string, public value: any, public path: string) { }
}

export class SetDefaultData implements Action {
    readonly type = dashboardTypes.SET_DEFAULT_DATA;
    public constructor(public path: string) { }
}


export type Actions =
    SetDefaultData |
    UpdateField |
    FetchPropertyGeneralRequest |
    FetchPropertyGeneralSuccess |
    FetchPropertyGeneralFailure |
    FetchBusinessGeneralRequest |
    FetchBusinessGeneralSuccess |
    FetchBusinessGeneralFailure;

